import { ResultOf } from "gql.tada";
import { RichTextRenderOverrides } from "@hooks/useRichTextRenderOptions";
import { ColumnLegalSectionById } from "@queries/entries/ColumnLegalSectionById";
import { IconGridFragment } from "@queries/fragments/IconGridFragment";
import { MediaItem } from "@components/shared/MediaItem";
import { RichText } from "@components/shared/core/RichText";

type Entry = ResultOf<typeof ColumnLegalSectionById>;

const overrides: RichTextRenderOverrides = {
  blocks: {
    embeddedEntry: {
      IconGrid: (node, _, { entryMap }) => {
        const embeddedEntry = entryMap.get(node.data.target.sys.id) as ResultOf<
          typeof IconGridFragment
        >;

        return (
          <div className="grid grid-cols-2 dsk:grid-cols-3">
            {embeddedEntry.iconsCollection?.items?.map((icon) => (
              <div
                key={icon?._id}
                className="max-w-[123px] dsk:max-w-[158px] aspect-square flex justify-center items-center"
              >
                {icon?.asset && (
                  <MediaItem
                    item={icon.asset}
                    className="w-full h-auto"
                    width={160}
                  />
                )}
              </div>
            ))}
          </div>
        );
      },
    },
  },
};

export const ColumnLegalSection = ({
  entry: { twoColumnRichTextSection: entry },
}: {
  entry: Entry;
}) => {
  if (!entry) return null;

  return (
    <section className="grid-base container-base py-[120px] bg-palette-current-deep/20">
      <div className="col-span-full dsk:col-span-7 dsk:col-start-2 [&_*]:text-brand-cream">
        <RichText content={entry.leftColumnRichText as any} overrides={overrides} />
      </div>
      <div className="col-span-full dsk:col-span-10 dsk:col-start-14 [&_*]:text-brand-cream">
        <RichText content={entry.rightColumnRichText as any} overrides={overrides} />
      </div>
    </section>
  );
};
